import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmDeliveries = styled('div')`
  .ant-drawer-footer {
    display: flex;
    gap: 10px;
  }

  .ant-table-thead {
    .ant-table-cell {
      font-weight: 400;
      color: ${(props) => props.theme.black};
    }
  }

  .ant-table-cell.centered-column {
    text-align: center;
  }

  .mobile-list-card-body-item {
    span {
      display: flex;
      flex-direction: column;
    }

    .ant-checkbox-wrapper {
      align-self: end;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .farm-deliveries-header {
      button {
        display: none;
      }
    }
  }
`;

export const PageLayoutWrapper = styled.div`
  &.hide-page-layout {
    .page-layout {
      padding: 0 !important;

      .ant-breadcrumb {
        display: none !important;
      }
    }
  }
`;
